<a type="button" [class.disabled]="!isEnterAllowed" class="btn btn-default" (click)="onTurnstileEnterClick()">{{
  'Enter' | translate }}</a>
<bSwitch switch-on-color='warning' switch-on-text="{{ 'Left side' | translate }}" switch-off-text="{{ 'Right side' | translate }}"
  [(ngModel)]="turnstileIsLeftSide" switch-handle-width="130">
</bSwitch>
